import * as fromDatatype from '../datatype-library/index';

export interface bl_ppl_ap_tnt_comp_receiver_mapping_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  tenant_code: fromDatatype.VarcharDatatypeInterface;
  tenant_guid: fromDatatype.GuidDataFieldInterface;
  tnt_company_hdr_guid: fromDatatype.GuidDataFieldInterface;
  tnt_company_peppol_id_guid: fromDatatype.GuidDataFieldInterface;
  tnt_company_hdr_peppol_id: fromDatatype.VarcharArrayDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status : fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_ppl_ap_tnt_comp_receiver_mapping_RowClass implements bl_ppl_ap_tnt_comp_receiver_mapping_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  tenant_code: fromDatatype.VarcharDatatypeInterface;
  tenant_guid: fromDatatype.GuidDataFieldInterface;
  tnt_company_hdr_guid: fromDatatype.GuidDataFieldInterface;
  tnt_company_peppol_id_guid: fromDatatype.GuidDataFieldInterface;
  tnt_company_hdr_peppol_id: fromDatatype.VarcharArrayDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status : fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}
